var side;
var ie6;
var sidefixed = 0;
var url;
var gifpngext;
var doctitle;
var overlay;
var fadeimages;
var affiliate;
// var pinit;
// var fbshare;
var currentspecial;
var highlyrecommended;
var menulink = null;
var dynamicrequest = null;
var header;
var topdiv;
var doshrink = true;
var mobile = false;
var tablet = false;
var mobileortablet = false;
var ScrollToDivActive = true;
var exDates;
var timeouts = Array();
var regionTimeouts = Array();
var checkoutform;
var winwidth;
var body;
var megamenus;
var googleMapsAPILoaded = false;
var googleMapsAPIKey = 'AIzaSyC_9NSk0cd2w2FjgtNo9uT7I1vy2V6fTeY';
var interact = 'touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup';

function navigationFadeOut(id) {
  $('#megamenus li a').removeClass('hover');

  $('#megamenu' + id).stop().fadeOut(0, function () {
    $('#megamenulink' + id).removeClass('hover');
  });
}

if (window.location.hash) {
  // Stop deafult behaviour
  window.scrollTo(0, 0)

  window.hash = window.location.hash;
}

if (document.images) {
  p = new Image();
  p.src = "/images/loading.gif";
  p = new Image();
  p.src = "/images/loadingproduct.gif";
  p = new Image();
  p.src = "/imagessite/loadingbasket.gif";
  p = new Image();
  p.src = "/images/daxarrow.png";
}

function formatDateISO(dDate) {
  return dDate.replace(new RegExp('-', 'g'), '/');
}

function formatDate(dDate) {
  var dd = dDate.getDate();
  var mm = dDate.getMonth() + 1; //January is 0!
  var yyyy = dDate.getFullYear();
  if (dd < 10) {
    dd = '0' + dd
  }
  if (mm < 10) {
    mm = '0' + mm
  }
  return yyyy + "-" + mm + "-" + dd + "";
}

var navigationSetup = function () {

  var mouse_is_inside = false;
  var mmactive = false;

  $('div.megamenu').hide();
  $('div.megamenu div.mminner').hover(function () {
    mouse_is_inside = true;
    //console.log('mouse_is_inside: ' + mouse_is_inside);

  }, function () {
    mouse_is_inside = false;
    //console.log('mouse_is_inside: ' + mouse_is_inside);
  });

  body.click(function (event) {
    if (!$(event.target).is('#megamenus li a') && !mouse_is_inside && mmactive) {
      $('div.megamenu').hide();
      $('#megamenus li a').removeClass('hover');
      mmactive = false;
      //console.log('mmactive: ' + mmactive);
    }
  });

  var hidebutton = $('<a>').attr('href', 'javascript:;').addClass('icon-close').click(function (event) {
    $(this).closest('div.megamenu').fadeOut(300);
    $('#megamenus li a').removeClass('hover');
    mmactive = false;
    //console.log(mmactive);
    event.preventDefault();
  });

  var bpg = $('<a>').attr('href', '/details/why-book-online-before-you-arrive/').addClass('bpg imagelink').click(function (event) {
    event.preventDefault();

    window.fancybox.open({
      src: $(this).attr('href') + '?popupwide=1',
      type: 'iframe'
    });

    /*
    $.colorbox({
        iframe: true,
        maxWidth: '100%',
        width: 820,
        height: 730,
        href: $(this).attr('href') + '?popupwide=1',
        close: '<span class="icon-close"></span>'
    });
    */
  });

  $('a.js-megamenu-trigger').bind('click', function () {
    var target = $(this).data('target');
    $('#megamenus li a[data-menu=' + target + ']').click()
  });

  $('#megamenus li a[data-menu]').each(function () {
    var mmid = $(this).data('menu');

    if ($('#megamenu' + mmid).length == 1) {
      $(this).bind('click', function (event) {
        var menuitem = $(this).parent();

        if (winwidth > 768) {
          if (!$(this).hasClass('desktopcloned')) {
            var thismmid = $(this).data('menu');

            //console.log(thismmid)

            $('#megamenu' + mmid).find('div.mminner').append(menuitem.find('> ul').clone());

            $(this).addClass('desktopcloned');
          }

          //clearTimeout(timeouts[mmid]);

          if (!$('#megamenu' + mmid).hasClass('hashide')) {

            $('#megamenu' + mmid).find('div.mminner').append(hidebutton.clone(true));
            $('#megamenu' + mmid).find('div.mminner').append(hidebutton.clone(true).addClass('icon-close-bottom'));
            $('#megamenu' + mmid).find('div.mminner').append(bpg.clone(true));
            $('#megamenu' + mmid).addClass('hashide');


            /*$('#'+popup).click(function(){
              $(this).fadeOut();
            });*/
          }

          if ($(this).hasClass('hover')) {
            //$('#megamenu'+mmid).unbind().stop().fadeOut(300);
            $(this).removeClass('hover');

            event.preventDefault();
            $('div.megamenu').stop().hide();

            mmactive = false;
            //console.log('mmactive: ' + mmactive);

          } else {
            event.preventDefault();
            $('div.megamenu').stop().hide();
            $('#megamenus li a').removeClass('hover');

            $(this).addClass('hover');

            var topOffset = ($(window).scrollTop() + topdiv.height());
            $('#megamenu' + mmid).css('top', topOffset).fadeIn(300, function () {
              $(this).css('opacity', 1);
              mmactive = true;
              //console.log('mmactive: ' + mmactive);

            });

            $('#megamenu' + mmid).mouseenter(function () {
              id = $(this).data('mega');
              //clearTimeout(timeouts[id]);
            });

            $('#megamenu' + mmid).mouseleave(function () {
              id = $(this).data('mega');
              //timeouts[id]=setTimeout(function(){navigationFadeOut(id);}, 2000);
            });
          }
        } else {
          if (!$(this).hasClass('mobilesetup')) {
            var thismmid = $(this).data('menu');

            //console.log(thismmid)

            if (!$(this).hasClass('mobilecloned')) {
              menuitem.append($('#megamenu' + thismmid + ' ul.featured,#megamenu' + thismmid + ' ul.links').clone())
              $(this).addClass('mobilecloned');
            }

            menuitem.find('h3').bind('click', function () {
              var h3item = $(this);
              if (h3item.hasClass('active')) {
                h3item.removeClass('active');
                h3item.next('ul').removeAttr('style');
              } else {
                // Don't close other menus on open
                //megamenus.find('h3').removeClass('active');
                //megamenus.find('h3 + ul').removeAttr('style');
                h3item.addClass('active');
                h3item.next('ul').css('display', 'flex').hide().slideDown();
              }
            });

            $(this).addClass('mobilesetup');
          }

          if (menuitem.hasClass('active')) {
            menuitem.removeClass('active').find('> ul').hide();
          } else {
            menuitem.addClass('active').find('> ul').css('display', 'flex').hide().slideDown();
          }
        }
      });

      /*
      $(this).mouseleave(function(){
        timeouts[mmid]=setTimeout(function(){navigationFadeOut(mmid);}, 2000);
      });

      $(this).mouseenter(function(){
        clearTimeout(timeouts[mmid]);
      });
      */
    };
  });
};

var grecaptchaInit = function (sitekey, action) {
  grecaptchaToken = $('#grecaptcha-token');

  grecaptcha.ready(function () {
    document.grecaptcha = grecaptcha;
    document.grecaptchasitekey = sitekey;
    document.grecaptchaaction = action;

    new grecaptchaReload(grecaptcha, sitekey, action);
    setTimeout(grecaptchaReloadWrapper, 45000);
  });
}

var grecaptchaReload = function (grecaptcha, sitekey, action) {
  grecaptcha.execute(sitekey, {
    action: action
  }).then(function (token) {
    $('#grecaptcha-token').val(token);
  });
}

function grecaptchaReloadWrapper() {
  new grecaptchaReload(document.grecaptcha, document.grecaptchasitekey, document.grecaptchaaction);
  setTimeout(grecaptchaReloadWrapper, 45000);
}

var postForm = function (form) {
  var formid = form.attr('id');
  var url = form.data('url');
  var split = form.data('split');

  form.submit(function (event) {
    form.addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/inc/' + url,
      data: form.serialize(),
      beforeSend: function () {
        $('#' + formid + ' input[type="image"]').each(function (event) {
          $(this).click(function (event) {
            event.preventDefault();
          });
        });
      },
      success: function (response) {
        if (split == 1) {
          var splitResult = response.split("###", 2);
          var htmlform = splitResult[0];
          var reload = splitResult[1];
        } else {
          var htmlform = response;
          var reload = 0;
        }

        form.html(htmlform);

        new links(0);
        new labelupInit(formid);

        if (reload == '1') {
          new basketReload('');
          new scrollToDiv($('#booktop'));
        }

        form.removeClass('loading');
      }
    });

    event.preventDefault();
  });
};

var postFormDisable = function (form) {
  var formid = form.attr('id');

  form.submit(function (event) {
    $('#' + formid + ' input[type="image"]').each(function (event) {
      $(this).click(function (event) {
        event.preventDefault();
      });
    });
  });
}

var postFormChange = function (formid, url, varqs, gvbook, dpbook) {
  var form = $('#' + formid);

  form.addClass('loading');

  $.ajax({
    type: 'POST',
    url: '/inc/' + url + '?change=1' + varqs,
    data: form.serialize(),
    success: function (response) {
      form.html(response);
      form.removeClass('loading');
      new links(0);
      if (gvbook == 1) {
        new checkMaxLength('gift_message', 160);
        if ($('#prettydate').length > 0) {
          new bookingFormDP();
        }
      }
      if (dpbook == 1) {
        new bookingFormDP();
      }

      new labelupInit(formid);
    }
  });
};

var paxperdayOnLoad = function () {
  $('.js-timeonly').each(function () {
    var qtyid = $(this).data('qty');
    var key = $(this).val();

    new paxperdayOnChange(qtyid, key);
    new paxperdayQTYOnChange(qtyid, key);

    $(this).change(function () {
      qtyid = $(this).data('qty');
      key = $(this).val();
      $('#' + qtyid + 'alert').remove();
      new paxperdayOnChange(qtyid, key);
      new paxperdayQTYOnChange(qtyid, key);
    });

    $('#' + qtyid).change(function () {
      new paxperdayQTYOnChange(qtyid, key);
    });
  });
};

var paxperdayQTYOnChange = function (qtyid, key) {
  var max_paxperday = paxperday[key];
  var qtyselect = $('#' + qtyid);
  var pax_selected = qtyselect.val();

  if (pax_selected > max_paxperday) { // Selected more than specials avaliable
    if ($('#' + qtyid + 'alert').length > 0) {
      $('#' + qtyid + 'alert').remove();
    }

    var pfield = qtyselect.closest('p.field');

    var selectedoption = pfield.find('select.js-timeonly').children('option:selected');

    var price = selectedoption.data('price');
    var price_was = selectedoption.data('price-was');
    var pax_extra = (pax_selected - max_paxperday);

    pfield.append(
      $('<span>')
        .attr('id', qtyid + 'alert')
        .addClass('clear e left')
        .text('Only ' + max_paxperday + ' left at ' + price + ', ' + pax_extra + ' will be charged at the normal price ' + price_was)
    );
  } else if (pax_selected <= max_paxperday && $('#' + qtyid + 'alert').length > 0) {
    $('#' + qtyid + 'alert').remove();
  }
};

var paxperdayOnChange = function (qtyid, key) {
  //var max_paxperday = paxperday[key];
  var qtyselect = $('#' + qtyid);

  var pfield = qtyselect.closest('p.field');

  var selectedoption = pfield.find('select.js-timeonly').children('option:selected');

  var max_paxperday = selectedoption.data('spaces');

  var pax_possible_values = qtyselect.data('pax').toString().split(',');
  var pax_selected = qtyselect.val();

  qtyselect.empty();
  qtyselect.append($("<option />").val(0).text(0));

  for (x = 0; x <= pax_possible_values.length; x++) {
    if (pax_possible_values[x] <= max_paxperday) {
      qtyselect.append($("<option />").val(pax_possible_values[x]).text(pax_possible_values[x]));
    }
  }

  qtyselect.val(pax_selected);
};

var currencyChange = function () {
  $('#currency').change(function () {
    $.ajax({
      type: 'GET',
      url: '/inc/changecurrency.php?currency=' + $(this).val(),
      success: function () {
        window.location.reload(true);
      }
    });
  });
};

var urlOnSelect = function (id) {
  $('#' + id).change(function () {
    window.location.href = $(this).val();
  });
};

var basketReload = function (vars) {
  $('#basket').load('/inc/cart_side.php' + vars, function () {
    $(this).removeClass('loading');
    new basketRemove();

  }).addClass('loading');
};

var basketRemove = function () {
  $('#basket a.remove').each(function () {
    $(this).click(function (event) {
      x = $(this).data('x');
      full = $(this).data('full');

      new basketReload('?remove=' + x + (full == '1' ? ('&full=1') : ''));
      event.preventDefault();

    });
  });
};

var toggleDiv = function (checkbox, divid) {
  var div = $('#' + divid);

  if (checkbox.checked == true) {
    div.removeClass('hidden').addClass('shown');
  } else {
    div.removeClass('shown').addClass('hidden');
  }
};

var toggleDivRev = function (checkbox, divid) {
  var div = $('#' + divid);

  if (checkbox.checked == true) {
    div.removeClass('shown').addClass('hidden');
  } else {
    div.removeClass('hidden').addClass('shown');
  }
};

var toggleSelectDiv = function (checkbox, divid, selected) {
  var div = $('#' + divid);

  if (selected == 1) {
    div.removeClass('hidden').addClass('shown');
  } else {
    div.removeClass('shown').addClass('hidden');
  }
};

var checkMaxLength = function (id, max) {
  $('#' + id).maxlength({
    max: max,
    showFeedback: 'alert',
    feedbackText: 'Used {c} of {m} characters'
  });
};
var revealReviews = function (id) {
  $('#' + id).css('display', 'none');

  var $reveallink = $('<a class="showhide" href="">Show More &darr;</a>').click(function (event) {
    $('#' + id).slideDown();

    $(this).hide();

    event.preventDefault();
  });

  var $hidelink = $('<a class="showhide" href="">Show Less &uarr;</a>').click(function (event) {
    $('#' + id).slideUp();

    $reveallink.show();

    event.preventDefault();
  });

  $('#' + id).before($reveallink);
  $('#' + id).append($hidelink);
};

var website = function (url) {
  newwindow = window.open(url, '_blank', '');
  newwindow.focus();
};

var popupWin = function (url, width, height) {
  popupWindow = window.open(url, '_blank', 'location=no,menubar=no,width=' + width + ',height=' + height + ',toolbar=no,scrollbars=yes,resizable=no');
  popupWindow.focus();
};

var links = function (popupvar) {
  var qspop;
  var owinwidth;
  var winwidth;
  var owinheight;
  var winheight;

  if (popupvar == 1) {
    new fixPopupLinks();
  } else {
    if ($("#search").length > 0) {
      new autoSearch();
    }

    $('a').each(function () {
      if ($(this).data('rel') == 'popup' || $(this).attr('rel') == 'popup' || $(this).data('rel') == 'popupwide' || $(this).attr('rel') == 'popupwide' || $(this).data('rel') == 'popupshort' || $(this).attr('rel') == 'popupshort') {
        $(this).unbind('click').click(function (event) {
          if ($(this).data('rel') == 'popup' || $(this).attr('rel') == 'popup') {
            qspop = 'popupwide';
            winheight = 730;
          } else if ($(this).data('rel') == 'popupwide' || $(this).attr('rel') == 'popupwide') {
            qspop = 'popupwide';
            winheight = 730;
          } else if ($(this).data('rel') == 'popupshort' || $(this).attr('rel') == 'popupshort') {
            qspop = 'popupwide';
            winheight = 450;
          }

          event.preventDefault();

          owinwidth = $(window).width();
          owinheight = $(window).height();
          winwidth = owinwidth; //Math.ceil(owinwidth*.9);

          if (mobile || tablet) {
            if (owinwidth > owinheight) { // Landscape
              winheight = Math.ceil(owinheight * .9);
            } else { // Portrait
              winheight = Math.ceil(owinheight * .5);
            }
          }

          var href = $(this).attr('href');
          var hash = '';
          if (href.indexOf("#") != -1) {
            hash = href.substr(href.indexOf("#"));
          }

          if (hash) {
            href = href.substr(0, href.indexOf("#"));
          }

          var iframecss = {
            height: winheight + 'px'
          };

          var altclose = false;
          if (affiliate) {
            var iframetop = $(this).offset().top;
            var scrolltop = $(this).scrollTop();
            var calcheight = iframetop;

            if ((winheight + iframetop) < owinheight) {
              altclose = true;
            } else if (iframetop > (winheight * 2)) {
              calcheight = (iframetop - winheight);
              altclose = true;
            }

            if (altclose) {
              iframecss = {
                height: 'calc(100% - ' + (calcheight + 44) + 'px)',
                position: 'absolute',
                top: calcheight + 'px',
                left: '50%',
                transform: 'translateX(-50%)'
              };
            }
          }

          window.fancybox.open({
            src: href + '?' + qspop + '=1' + hash,
            type: 'iframe',
            iframe: {
              css: iframecss
            },
            afterLoad: function () {
              if (altclose) {
                $('.fancybox-content').append($('<a></a>').addClass('altclose icon-close').attr('href', 'javascript:;').click(function () {
                  window.fancybox.close();
                }))
              }
            }
          });

          /*
          $.colorbox({
              iframe: true,
              initialWidth: winwidth,
              maxWidth: 820,
              width: winwidth,
              height: winheight,
              href: href + '?' + qspop + '=1' + hash,
              close: '<span class="icon-close"></span>'
          });
          */
        })

      } else if ($(this).data('rel') == 'popupshare') {
        $(this).click(function (event) {
          event.preventDefault();
          new popupWin($(this).attr('href'), 860, 450);
        });
      } else if ($(this).data('rel') == 'popupchat') {
        $(this).click(function (event) {
          event.preventDefault();
          new popupWin($(this).attr('href'), 500, 600);
        });
      }
    });
  }
};

var fixPopupLinks = function () {
  $('a').each(function () {
    if (
      $(this).attr('target') != '_blank' &&
      $(this).attr('target') != '_self' &&
      $(this).data('rel') != 'popup' &&
      $(this).attr('rel') != 'popup' &&
      $(this).data('rel') != 'popupshort' &&
      $(this).attr('rel') != 'popupshort' &&
      $(this).data('rel') != 'popupwide' &&
      $(this).attr('rel') != 'popupwide'
    ) {
      $(this).attr('target', '_top');
    }
  });
};

var embedVideo = function () {
  $('#productvideo').click(function (event) {
    $('#thumbs a').css('opacity', 1);

    $('#productimage').html('<iframe width="713" height="356" src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen></iframe>');
    event.preventDefault();
  });
};

var stayLoggedIn = function () {
  var url = '/inc/stayloggedin.php';

  $.ajax({
    type: 'GET',
    url: url
  });
};

var autoSearch = function () {
  var cache = {},
    lastXhr;

  $("#search").keyup(function () {
    $("#searchrecord").val($("#search").val());
  });

  $("#search").blur(function () {
    if (dynamicrequest) {
      dynamicrequest.abort();
    }

    dynamicrequest = $.ajax({
      type: 'GET',
      url: '/inc/searchrecord.php?record=' + $("#searchrecord").val(),
      success: function () {
        dynamicrequest = null;
      }
    });
  });

  $("#search").autocomplete({
    minLength: 2,
    source: function (request, response) {
      var term = request.term;
      if (term in cache) {
        response(cache[term]);
        return;
      }

      lastXhr = $.getJSON("/inc/autocomplete.php", request, function (data, status, xhr) {
        cache[term] = data;
        if (xhr === lastXhr) {
          response(data);
        }
      });
    },
    focus: function (event, ui) {
      $("#search").val(ui.item.name);
      return false;
    },
    select: function (event, ui) {
      $("#search").val(ui.item.name);

      return false;
    },
    open: function () {
      $(this).autocomplete('widget').zIndex(1000);
    }
  }).data("autocomplete")._renderItem = function (ul, item) {
    return $("<li></li>")
      .data("item.autocomplete", item)
      .append("<a href='" + item.url + "' class='go'>" + item.name + "</a>")
      .appendTo(ul);
  };
};

var expandableText = function (selector, wexpand) {
  var sp = ((mobile || tablet) ? 300 : 500);
  var ww = 50;
  if ($(selector).data('slice') !== undefined) {
    sp = $(selector).data('slice');
    ww = 5;
  }

  $(selector).expander({
    slicePoint: sp,
    widow: ww,
    expandText: 'More&nbsp;information',
    userCollapseText: 'Show&nbsp;less',
    userCollapse: true,
    preserveWords: true,
    collapseEffect: 'hide',
    collapseSpeed: 0,
    afterExpand: function () {
      new links(0);
    }
  });

  /*
  var winwidth = $(window).width();

  if (winwidth > 978 && wexpand) {
    $('section.wide .read-more a, div.expandable:not(.js-expandable) .read-more a').click();
  }
  */
};

/*
var fadeImagesActive = function (siteurl, fadetype, sitename) {
  currentimage = $('.cycle-slide-active');

  titleorig = currentimage.data('title');
  region = currentimage.data('region');
  url = currentimage.data('url');
  overlay.attr('href', '/' + url + '/');

  if (fadetype == 1) {
    if (!mobileortablet) {
      $('#overlay').unbind().qtip({
        position: {
          target: 'mouse',
          adjust: {
            x: 8,
            y: 8
          }
        },
        content: {
          text: titleorig + (region == '' ? '' : (': ' + region)),
          title: {
            text: sitename
          }
        }
      });
    }
  } else if (fadetype == 0) {
    title = (url == '' ? $('<span></span>').html(titleorig) : ($('<a></a>').text(titleorig).attr('href', '/' + url + '/')));

    currentspecial.css('display', (currentimage.data('special') == 1 ? 'block' : 'none'));
    highlyrecommended.css('display', (currentimage.data('recommended') == 1 ? 'block' : 'none'));

    highlyrecommended.removeClass('highlyrecommendedt');

    if ($(this).data('special') == 0) {
      highlyrecommended.addClass('highlyrecommendedt');
    }

    $('#imagetitle').html(title).append((region != '' ? ('<br />' + region) : ''));
    $('#imagedesc').html(currentimage.data('desc'));
  }

  //pinit.attr('href', '//pinterest.com/pin/create/button/?url=' + encodeURIComponent(siteurl + '/' + url + '/') + '&media=' + encodeURIComponent(siteurl + currentimage.attr('src')) + '&description=' + encodeURIComponent(titleorig));
};
*/

var fadeImages = function () {
  fadeimages = $('#fadeimages');
  siteurl = fadeimages.data('siteurl');
  fadetype = fadeimages.data('fadetype');
  sitename = fadeimages.data('sitename');
  overlay = $('#overlay');
  //pinit = $('#pinit');
  //fbshare = $('#fbshare');
  currentspecial = $('#currentspecial');
  highlyrecommended = $('#highlyrecommended');

  fadeimages.slick({
    infinite: true,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    customPaging: function (slider, i) {
      return $('<button type="button" />').attr('aira-label', i + 1);
    }
  });
  /*
  fadeimages.cycle({
    speed: 500,
    timeout: 7500,
    pager: '#fadeimagesnav',
    pauseOnPagerHover: 1
  }).on('cycle-after', function (event, opts, outgoingSlideEl) {
    new fadeImagesActive(siteurl, fadetype, sitename);
  });

  overlay.mouseenter(function () {
    $('.cycle-slideshow').cycle('pause');
  });

  overlay.mouseleave(function () {
    $('.cycle-slideshow').cycle('resume');
  });

  //fbshare.attr('href', '//www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(siteurl + '/' + url + '/'));
  */
  // Get initial image
  //new fadeImagesActive(siteurl, fadetype, sitename);
};

var scrollToDiv = function (element) {
  if (ScrollToDivActive) {
    var offset = element.offset();
    var totalScroll = offset.top;

    var topOffset = (doshrink ? topdiv.height() : 0);

    $('body,html').animate({
      scrollTop: (totalScroll - topOffset)
    }, 500);
  }
};

var ccpOption = function () {
  $('#ccpyes, #ccpno, #fandbyes, #fandbno').change(function () {
    var payreq = checkoutform.data('payreq');
    var totalvalue = $('#totalvalue').val();
    var ccpvalue = 0;
    var fandbvalue = 0;

    if ($('#ccpyes').length) {
      ccpvalue = ($('#ccpyes').is(':checked') ? 2 : ccpvalue);
    }
    if ($('#ccpno').length) {
      ccpvalue = ($('#ccpno').is(':checked') ? 1 : ccpvalue);
    }
    if ($('#fandbyes').length) {
      fandbvalue = ($('#fandbyes').is(':checked') ? 2 : fandbvalue);
    }
    if ($('#fandbno').length) {
      fandbvalue = ($('#fandbno').is(':checked') ? 1 : fandbvalue);
    }

    if (payreq == 0 && (ccpvalue == 2 || fandbvalue == 2)) {
      checkoutform.submit();
    } else if (payreq == 1 && (ccpvalue == 1 || fandbvalue == 1) && totalvalue == '0.00') {
      checkoutform.submit();
    } else {
      var totaldepositvalue = $('#totaldepositvalue').val();

      $.ajax({
        type: 'GET',
        url: '/inc/totals.php',
        data: 'ccp=' + ccpvalue + '&fandb=' + fandbvalue + '&totalvalue=' + totalvalue + '&totaldepositvalue=' + totaldepositvalue,
        success: function (response) {
          $('#total').html(response);
        }
      });
    }

    new scrollToDiv($('#paymentdetails'));
  });
};

var abandonedBasket = function () {
  $('#email').blur(function () {
    var fname = $('#fname').val();
    var lname = $('#lname').val();
    var town_city = $('#town_city').val();
    var country = $('#country').val();
    var email = $('#email').val();
    var phone = $('#phone').val();

    if (isEmail(email)) {
      if (dynamicrequest) {
        dynamicrequest.abort();
      }

      dynamicrequest = $.ajax({
        type: 'GET',
        url: '/inc/abandonedbasket.php',
        data: 'email=' + email + '&fname=' + fname + '&lname=' + lname + '&town_city=' + town_city + '&country=' + country + '&phone=' + phone,
        success: function (response) {
          //console.log(response);
        }
      });
    }

  });
};

/*
var creditCardV = function () {
  return $('#card_number').validateCreditCard(function (result) {
    if (!(result.card_type != null)) {
      $('#cards span.card').removeClass('off');
      $('#card_number').removeClass('valid').parent().removeClass('icon-tickafter');

      return;
    }

    $('#cards span.card').addClass('off');
    $('#cards span.' + result.card_type.name).removeClass('off');

    if (result.length_valid && result.luhn_valid) {
      return $('#card_number').addClass('valid').parent().addClass('icon-tickafter');
    } else {
      return $('#card_number').removeClass('valid').parent().removeClass('icon-tickafter');
    }
  });
};
*/

var preventEnterReturn = function () {
  $(window).keydown(function (event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });
};

var responsiveSetup = function () {
  if (winwidth <= 768) {
    $('div.megamenu').removeAttr('style');
  }

  if (winwidth <= 768 && !body.hasClass('menucloned')) {
    $menubutton = $('<button></button>').addClass('hamburger');
    $menubutton.attr('href', '#menu').prepend('<span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="hamburger-text">MENU</span>').on('click', function (e) {
      e.preventDefault();

      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        megamenus.removeClass('megamenus--open');
      } else {
        $(this).addClass('is-active');
        megamenus.addClass('megamenus--open');
      }
    });

    $menubutton.prependTo(header);
    body.addClass('menucloned');

    /*megamenus.find('h3').bind('click', function() {
        var h3item = $(this);
        if (h3item.hasClass('active')) {
            h3item.removeClass('active');
            h3item.next('ul').removeAttr('style');
        } else {
            // Don't close other menus on open
            //megamenus.find('h3').removeClass('active');
            //megamenus.find('h3 + ul').removeAttr('style');
            h3item.addClass('active');
            h3item.next('ul').css('display', 'flex').hide().slideDown();
        }
    });*/

  } else if (winwidth > 768 && body.hasClass('menucloned')) {
    megamenus.removeClass('megamenus--open');
    megamenus.find('h3').removeClass('active');
    megamenus.find('ul').removeAttr('style');
    $menubutton.removeClass('is-active');
  }

  new expandableText('.js-expandable', 0);

  /*
  if (winwidth <= 978 && doshrink) {
    doshrink = false;

    //topdiv.removeClass("shrink");

    new expandableText('div.expandable:not(.js-expandable)', 1);

  } else if (!doshrink) {
    doshrink = true;
    if (winwidth > 978) {
      $('div.expandable:not(.js-expandable) .read-more a').click();
    }
  }
  */
};

var productsPagination = function (file, classname, url, page, sqlqtype, max, term, section, totaltoshow, urlArray) {
  var pagination = $('#pagination');
  var paginationloading = $('#paginationloading');

  if (max > totaltoshow) {
    urlArray = (urlArray == '' ? '{}' : urlArray);
    $('#pagination').scrollPagination({
      'contentPage': '/inc/' + file + '.php?url=' + url + '&sqlqtype=' + sqlqtype + '&term=' + term + '&section=' + section + '&urlArray=' + $.parseJSON(urlArray),
      'contentData': {},
      'contentClass': '#pagination div.' + classname,
      'scrollTarget': $(window),
      'heightOffset': $(window).height(),
      'beforeLoad': function () {
        paginationloading.addClass('paginationloading--visible');
      },
      'afterLoad': function (elementsLoaded) {
        paginationloading.removeClass('paginationloading--visible');
        var i = 0;
        $(elementsLoaded).fadeInWithDelay();

        if (classname == 'product') {
          new productsH2Links();
        }

        $('#pagination div.' + classname + ' img.lazy[data-lazy]').lazyload({ data_attribute: "lazy" });

        if ($('#pagination div.' + classname).length >= max) {
          pagination.stopScrollPagination();
        }

        $('ul.results').html('<li class="wide">Displaying ' + $('#pagination div.' + classname).length + ' of ' + max + ' results</li>');
      }
    });

    $('ul.results').html('<li class="wide">Displaying ' + totaltoshow + ' of ' + max + ' results</li>');
  }
};

var productsLoadMore = function (file, classname, url, page, sqlqtype, max, term, section, totaltoshow, urlArray) {
  var pagination = $('#pagination');
  var paginationloading = $('#paginationloading');
  var paginationloadmore = $('#paginationloadmore');

  if (max > totaltoshow) {
    urlArray = (urlArray == '' ? '' : $.parseJSON(urlArray));

    paginationloadmore.click(function (e) {
      e.preventDefault();
      $(pagination).children().attr('rel', 'loaded');

      paginationloading.addClass('paginationloading--visible');

      $.ajax({
        type: 'GET',
        url: '/inc/' + file + '.php?url=' + url + '&sqlqtype=' + sqlqtype + '&term=' + term + '&section=' + section + '&urlArray=' + urlArray + '&totaltoshow=' + totaltoshow + '&page=' + (Math.ceil($('#pagination div.' + classname).length / 10) + 1),
        success: function (response) {
          $(pagination).append(response);
          var objectsRendered = $(pagination).children('[rel!=loaded]');
          objectsRendered.fadeInWithDelay();

          paginationloading.removeClass('paginationloading--visible');

          if (classname == 'product') {
            new productsH2Links();
          }

          $('#pagination div.' + classname + ' img.lazy[data-lazy]').lazyload({ data_attribute: "lazy" });

          if ($('#pagination div.' + classname).length >= max) {
            paginationloadmore.closest('ul').hide();
          }

          $('ul.results').html('<li class="wide">Displaying ' + $('#pagination div.' + classname).length + ' of ' + max + ' results</li>');
        }
      });
    });

    $('ul.results').html('<li class="wide">Displaying ' + totaltoshow + ' of ' + max + ' results</li>');
  } else {
    paginationloadmore.hide();
  }
};

// code for fade in element by element
$.fn.fadeInWithDelay = function () {
  var delay = 0;
  return this.each(function () {
    $(this).delay(delay).animate({
      opacity: 1
    }, 200);
    delay += 100;
  });
};

var productsH2Links = function () {
  $('div.producti h2:not(.linksadded)', '#content').each(function () {
    $(this).addClass('linksadded').css('cursor', 'pointer');
    $(this).click(function () {
      document.location.href = $(this).data('href');
    });
  });
}

var $ajaxload;
var dp;

var bookingFormDP = function () {
  var datefield = $('#date');
  var setdate = datefield.data('setdate');
  exDates = eval(datefield.data('exdates'));
  dp = $("#prettydate").datepicker({
    showOn: 'button',
    buttonText: '<span class="icon-cal"></span>',
    dateFormat: 'DD, d MM yy',
    numberOfMonths: 1,
    altField: "#date",
    altFormat: "yy-mm-dd",
    minDate: 0,
    maxDate: "+1Y",
    beforeShowDay: excludeDates,
    onSelect: function () {
      new postFormChange('bookingtheform', 'display_booking_form.php', '&step_override=1', 0, 1)
    }
  });

  if (setdate) {
    dp.datepicker('setDate', getMinDate());
  }

  $("#prettydate").hover(function () {
    dp.datepicker('show')
  });
  $('img.ui-datepicker-trigger').hover(function () {
    dp.datepicker('show')
  });
  $('#prettydate').css({
    'display': 'inline'
  });
  datefield.removeClass('input').addClass('invis');

  new paxperdayOnLoad();
}

var tableScroll = function (classname) {
  var $table = $(classname);
  var $fixedColumn = $table.clone().insertBefore($table).addClass('fixed-column');

  $fixedColumn.find('th:not(:first-child),td:not(:first-child)').remove();

  $fixedColumn.find('tr').each(function (i, elem) {
    $(this).height($table.find('tr:eq(' + i + ')').height());
  });

  $(window).resize(function () {
    $fixedColumn.find('tr').each(function (i, elem) {
      $(this).height($table.find('tr:eq(' + i + ')').height());
    });
  });
};

var labelupInit = function (prefix) {
  $((prefix ? ('#' + prefix + ' ') : '') + 'p.field--labelup').find('input.input,textarea').each(function () {
    if ($(this).val() != '') {
      $(this).closest('.field--labelup').addClass('field--labelup--hasvalue');
    } else {
      $(this).closest('.field--labelup').removeClass('field--labelup--hasvalue');
    }

    $(this).on('change keyup blur input', function () {
      if ($(this).val() != '') {
        $(this).closest('.field--labelup').addClass('field--labelup--hasvalue');
      } else {
        $(this).closest('.field--labelup').removeClass('field--labelup--hasvalue');
      }
    });
  });
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function excludeDates(date) {
  for (i = 0; i < exDates.length; i++) {
    if (date.getMonth() == exDates[i][0] - 1 && date.getDate() == exDates[i][1] && (date.getYear() == exDates[i][2] || exDates[i][2] == 0)) {
      return [false, ''];
    }
  }
  return [true, ''];
}

function getMinDate() {
  var date = new Date();
  while (!excludeDates(date)[0]) {
    date.setDate(date.getDate() + 1);
  }
  return date;
}

(function ($) {
  ie6 = false;

  footer = $("footer");
  header = $("header");
  topdiv = $("div.top");
  body = $('body');
  megamenus = $('#megamenus');
  affiliate = ($('body').hasClass('aff') ? true : false);
  mobile = (footer.data('mobile') == 1 ? true : false);
  tablet = (footer.data('tablet') == 1 ? true : false);
  mobileortablet = (mobile || tablet ? true : false);
  popup = (footer.data('popup') == 1 ? true : false);
  winwidth = $(window).width();

  new labelupInit('');

  new links(popup);

  new responsiveSetup();
  new navigationSetup();
  new currencyChange();

  if ($('img.lazy[data-lazy]').length) {
    $('img.lazy[data-lazy]').lazyload({ data_attribute: "lazy" });
  }

  if ($('#fadeimages').length > 0) {
    new fadeImages();
  }

  /*
  if($('.js-specialstable').length > 0){
    new tableScroll('.js-specialstable');
  }
  */

  if ($('#revealreviews').length > 0) {
    new revealReviews('revealreviews');
  }

  if ($('form.postform').length > 0) {
    $('form.postform').each(function () {
      new postForm($(this));
    });
  }

  if ($('form.postformdisable').length > 0) {
    $('form.postformdisable').each(function () {
      new postFormDisable($(this));
    });
  }

  if ($('#prettydate').length) {
    $.ajaxSetup({
      cache: true
    });
    $.getScript("/js/modules/jquery-ui-datepicker.js", function () {
      new bookingFormDP();
    });
  }

  if ($('#basket').length > 0) {
    new basketRemove();
  }

  if ($('.scrolltodiv').length > 0) {
    $('.scrolltodiv').each(function () {
      var scrolltodiv = $(this).data('scrolltodiv');
      if (scrolltodiv != '') {
        new scrollToDiv($(scrolltodiv));
      }
    });
  }


  if ($('#checkoutform').length > 0) {
    checkoutform = $('#checkoutform');
    new ccpOption();
    new abandonedBasket();
    new preventEnterReturn();
    new postFormDisable(checkoutform);
    //new creditCardV();
  }

  if ($('ol.faqs').length > 0) {
    new attachFAQs();
  }

  $('.js-hrefonchange').change(function () {
    window.location.href = $(this).val();
  });

  var uisortloaded = false;
  if ($('.sortablelist').length) {
    uisortloaded = true;
    $.getScript("/js/modules/jquery-ui-sortable.js", function () {
      $('.sortablelist').sortable();
    });
  }

  /*
  if ($('.chzn-select.chzn-sortable').length) {
    $.ajaxSetup({
      cache: true
    });
    if(!uisortloaded){
      $.getScript("/js/modules/jquery-ui-sortable.js", function () {
        $(".chzn-select").chosen().chosenSortable();
      });
    }
  } else {
    $(".chzn-select").chosen();
  }
  */

  $(".chzn-select").chosen();

  new productsH2Links();

  /*
  $('#processmybooking').click(function (event) {
    if ($(this).hasClass('disabled')) {
      event.preventDefault();
    } else {
      $(this).addClass('disabled');
    }
  });
  */

  // EQ Wallpaper download
  if ($('#wallpaperlinks').length > 0) {
    $('#wallpaperlinks a').click(function () {
      try {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Wallpaper',
          eventAction: 'Click',
          eventLabel: $(this).text(),
          eventValue: 1
        });
      } catch (e) { }
    });
  }

  var refreshId = setInterval(stayLoggedIn, 60000);

  $(window).resize(function () {
    winwidth = $(window).width();
    new responsiveSetup();
  });

  if ($('#js-fblike').length) {
    var fblike = $('#js-fblike');
    var loadfblike = true;

    $('#js-fblike:in-viewport').each(function () {
      if (loadfblike) {
        loadfblike = false;
        fblike.attr('src', fblike.data('src'));
      }
    });

    $(window).scroll(function () {
      $('#js-fblike:in-viewport').each(function () {
        if (loadfblike) {
          loadfblike = false;
          fblike.attr('src', fblike.data('src'));
        }
      });
    });
  }

  if ($('.js-carousel').length) {
    $('.js-carousel').find('img.lazy').each(function () {
      $(this).removeClass('lazy');
    });
    $('.js-carousel').slick({
      infinite: false,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      lazyLoad: 'progressive',
      customPaging: function (slider, i) {
        return $('<button type="button" />').attr('aira-label', i + 1);
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            useTransform: false,
            useCSS: false,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 450,
          settings: {
            useTransform: false,
            useCSS: false,
            slidesToShow: 2,
          }
        },
      ]
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
      let slidesLength = slick.$slides.length - slick.options.slidesToShow, slider = $(this);

      if (currentSlide === slidesLength) {
        setTimeout(function () {
          slider.slick("slickGoTo", 0);
        }, slick.options.autoplaySpeed)
      }
    });

    var st = 0;

    $('.js-carousel').each(function () {
      var cid = $(this).attr('id');
      setTimeout(function () {
        $('#' + cid).slick('slickPlay');

      }, st);

      st = st + 500;
    });
  }

  if ($('[data-vbg]').length) {
    $.when(
      $.getScript('/js/ytbg.js'),
      $.Deferred((deferred) => {
        $(deferred.resolve);
      }),
    ).done(() => {
      $(document).trigger('scroll');
    });
  }

  if ($('#productimageholder').length) {
    $.ajaxSetup({
      cache: true
    });
    $.getScript("/js/modules/sfg.js?v2");
  }

  if ($('#regionmap').length > 0) {
    $.ajaxSetup({
      cache: true
    });
    $.getScript("/js/modules/regionmap.js");
  }

  if ($('#pricestable').length > 0) {
    $.ajaxSetup({
      cache: true
    });

    $.when(
      $.getScript('/js/modules/jquery-ui-datepicker.js'),
      $.getScript('/js/modules/pricestable.js'),
      $.Deferred((deferred) => {
        $(deferred.resolve);
      }),
    ).done(() => {
      new pricesTableSetup(1);
    });
  }

  if ($('#tabstop').length > 0) {
    $.ajaxSetup({
      cache: true
    });
    $.getScript("/js/modules/tabs.js");
  }

  if ($('#js-comparison').length > 0) {
    $.ajaxSetup({
      cache: true
    });
    $.getScript("/js/modules/comparison.js");
  }

  if (window.location.hash) {
    window.hash = window.location.hash.substring(1).replace('/', '-')

    if (window.hash && window.hash !== 'undefined' && $('#' + window.hash).length) {
      let hashElem = document.getElementById(window.hash)
      setTimeout(function () {
        new scrollToDiv($('#' + window.hash));
      }, 500)
    }
  }

}(jQuery));
